import { Trans } from 'react-i18next';

import success from 'assets/animations/success.json';

import { useAuth } from 'providers/Auth';
import { useLang } from 'hooks';

import { Button, Column } from 'components/Blocks';
import { SVGAnimation } from 'components/SVGAnimation';

export function CodeSent() {
  const { navigateToCodeInput } = useAuth();

  const { t } = useLang();

  return (
    <>
      <SVGAnimation size={120} className="mx-auto" animationData={success} />

      <Column gap="5">
        <h3 className="text-2xl font-medium text-success">{t('success')}!</h3>

        <p className="[&_strong]:text-primary">
          <Trans>a-confirmation-code-was-sent-to-your-slack</Trans>.
        </p>

        <Button variant="link" onClick={navigateToCodeInput} className="font-normal underline">
          {t('I-have-got-my-code')}
        </Button>
      </Column>
    </>
  );
}
